(() => {
  if (window.velmaraNativeCart) return;
  window.velmaraNativeCart = true;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const drawer = () => document.getElementById('cart-drawer');
  const state = { queue: Promise.resolve(), timer: null, deadline: 0, refreshTimer: null, lastFocus: null, busy: false, resizeObserver: null, externalBusy: false, openAfterRefresh: false };
  const errorMessage = () => drawer()?.dataset.errorMessage || 'Impossibile aggiornare il carrello. Riprova.';
  const cartData = () => { try { const data = JSON.parse(drawer()?.querySelector('[data-vm-cart]')?.textContent || '{}'); for (const line of data.items || []) if (Array.isArray(line.properties)) line.properties = Object.fromEntries(line.properties); return data; } catch { return {}; } };
  const showError = message => { const node = drawer()?.querySelector('[data-vm-error]'); if (node) { node.textContent = message; node.hidden = false; } };
  const tick = () => {
    const clock = drawer()?.querySelector('[data-vm-clock]');
    const banner = drawer()?.querySelector('[data-vm-timer]');
    if (!clock || !banner) return;
    const remaining = Math.max(0, Math.ceil((state.deadline - Date.now()) / 1000));
    clock.textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
    banner.hidden = remaining === 0;
  };
  const initialize = () => {
    const element = drawer();
    if (!element?.classList.contains('vm-cart')) return;
    const data = cartData();
    if (!data.item_count) { state.deadline = 0; try { sessionStorage.removeItem('vm-cart-deadline'); } catch {} }
    else if (!state.deadline) {
      try { state.deadline = Number(sessionStorage.getItem('vm-cart-deadline')) || 0; } catch {}
      if (!state.deadline) { state.deadline = Date.now() + Number(element.dataset.duration || 295) * 1000; try { sessionStorage.setItem('vm-cart-deadline', String(state.deadline)); } catch {} }
    }
    element.querySelector('[data-vm-count]').textContent = String(data.item_count || 0);
    tick();
    const track = element.querySelector('[data-vm-track]');
    const updateArrows = () => {
      if (!track) return;
      element.querySelector('[data-vm-scroll="-1"]').disabled = track.scrollLeft < 3;
      element.querySelector('[data-vm-scroll="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    };
    state.resizeObserver?.disconnect();
    if (track) { state.resizeObserver = new ResizeObserver(updateArrows); state.resizeObserver.observe(track); }
    track?.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  };
  const refresh = async (open = false) => {
    const element = drawer();
    if (!element) return;
    const sectionId = element.dataset.sectionId;
    const url = new URL(root, location.origin);
    url.searchParams.set('sections', sectionId);
    const [cart, sections] = await Promise.all([nativeFetch(`${root}cart.js`).then(r => r.json()), nativeFetch(url).then(r => r.json())]);
    if (!sections[sectionId]) throw new Error(errorMessage());
    cart.sections = sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart, baseEvent: open ? 'variant:add' : 'velmara:update' } }));
    if (open && cart.item_count) element.show();
    return cart;
  };
  const scheduleRefresh = (open = false) => {
    state.openAfterRefresh = state.openAfterRefresh || open;
    clearTimeout(state.refreshTimer);
    state.externalBusy = true;
    drawer()?.setAttribute('aria-busy', 'true');
    state.refreshTimer = setTimeout(() => {
      const shouldOpen = state.openAfterRefresh;
      state.openAfterRefresh = false;
      state.queue = state.queue.catch(() => {}).then(() => refresh(shouldOpen)).catch(error => showError(error.message)).finally(() => { state.externalBusy = false; if (!state.busy) drawer()?.removeAttribute('aria-busy'); });
    }, 400);
  };
  window.fetch = async function(input, options) {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input?.url || '';
    const method = String(options?.method || input?.method || 'GET').toUpperCase();
    const modifiesCart = method !== 'GET' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url);
    if (modifiesCart) { state.externalBusy = true; drawer()?.setAttribute('aria-busy', 'true'); }
    try {
      const response = await nativeFetch(input, options);
      if (modifiesCart) scheduleRefresh(response.ok && /\/cart\/add/.test(url));
      return response;
    } catch (error) { if (modifiesCart) scheduleRefresh(); throw error; }
  };
  const mutation = async (endpoint, payload) => {
    const response = await nativeFetch(`${root}cart/${endpoint}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || errorMessage());
    return data;
  };
  const quantityChange = async (key, quantity) => {
    const items = cartData().items || [];
    const item = items.find(line => line.key === key);
    const bundle = line => { try { return JSON.parse((line.properties?.__kaching_bundles || '{}').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&')); } catch { return {}; } };
    const group = item && bundle(item);
    if (quantity === 0 && group?.id && !group.gift) {
      const remaining = items.some(line => line.key !== key && bundle(line).id === group.id && !bundle(line).gift && line.quantity > 0);
      if (!remaining) {
        const updates = { [key]: 0 };
        items.filter(line => bundle(line).id === group.id && bundle(line).gift).forEach(line => { updates[line.key] = 0; });
        return mutation('update', { updates });
      }
    }
    return mutation('change', { id: key, quantity });
  };
  const perform = action => {
    if (state.busy) return;
    state.busy = true;
    drawer()?.setAttribute('aria-busy', 'true');
    state.queue = state.queue.catch(() => {}).then(action).then(() => refresh()).catch(error => showError(error.message)).finally(() => { state.busy = false; drawer()?.removeAttribute('aria-busy'); });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[aria-controls="cart-drawer"]');
    if (!trigger || trigger.closest('.vm-cart')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    customElements.whenDefined('cart-drawer').then(() => refresh(true)).catch(error => showError(error.message));
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-vm-quantity], [data-vm-scroll]');
    if (!target?.closest('.vm-cart')) return;
    event.preventDefault();
    if (target.hasAttribute('data-vm-scroll')) { const track = drawer().querySelector('[data-vm-track]'); track.scrollTo({ left: track.scrollLeft + Number(target.dataset.vmScroll) * (track.clientWidth + 12), behavior: 'instant' }); return; }
    const line = target.closest('[data-vm-line]');
    const quantity = Number(target.dataset.vmQuantity);
    perform(() => quantityChange(line.dataset.vmLine, quantity));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('.vm-cart [data-vm-input]')) {
      const quantity = Number(event.target.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0) { event.target.value = event.target.defaultValue; return; }
      perform(() => quantityChange(event.target.closest('[data-vm-line]').dataset.vmLine, quantity));
    }
    if (event.target.matches('.vm-cart [data-vm-upsell] select')) {
      const option = event.target.selectedOptions[0], card = event.target.closest('[data-vm-recommendation]');
      card.querySelector('[data-vm-price]').textContent = option.dataset.price;
      card.querySelector('[data-vm-compare]').textContent = option.dataset.compare;
      card.querySelector('[data-vm-compare]').hidden = option.dataset.onSale !== 'true';
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-vm-upsell]')) {
      event.preventDefault();
      const id = Number(new FormData(event.target).get('id'));
      perform(() => mutation('add', { items: [{ id, quantity: 1 }] }));
    }
    if (event.target.matches('[data-vm-checkout]') && (state.busy || state.externalBusy)) { event.preventDefault(); }
  }, true);
  document.addEventListener('cart-drawer:refreshed', initialize);
  document.addEventListener('dialog:after-show', event => { if (event.target === drawer()) initialize(); });
  window.upcartOpenCart = () => { scheduleRefresh(true); return Promise.resolve(); };
  window.upcartCloseCart = () => drawer()?.hide();
  window.upcartRefreshCart = () => { scheduleRefresh(); return Promise.resolve(); };
  window.upcartUpdateCart = window.upcartRefreshCart;
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  customElements.whenDefined('cart-drawer').then(initialize);
  state.timer = setInterval(tick, 1000);
})();
